"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var parseCookies = lodash_1.memoize(function (documentCookie) {
    var rawCookies = documentCookie.split('; ');
    var cookies = {};
    rawCookies.forEach(function (candidate) {
        var _a = candidate.split('='), key = _a[0], value = _a[1];
        cookies[key] = value;
    });
    return cookies;
});
function getCookie(name) {
    return parseCookies(document.cookie)[name];
}
exports.getCookie = getCookie;
//# sourceMappingURL=cookies.js.map